import { useState } from "react";
import { useQueryClient } from "react-query";
import { updateCustomCladColorPrice } from "../../api/OrderSummaryApi";

function useCustomCladColorInput(
  quoteId: string,
  initialCustomCladColorPrice: number | null,
) {
  const initialCustomCladColorPriceAsString = initialCustomCladColorPrice ? initialCustomCladColorPrice.toString() : "0"
  const [customCladColorPrice, setCustomCladColorPrice] = useState<string>(initialCustomCladColorPriceAsString);
  const [editCustomCladColorPriceClicked, setEditCustomCladColorPriceClicked] =
    useState(false);
  const [isUpdatingCustomCladColorPrice, setIsUpdatingCustomCladColorPrice] =
    useState(false);
  const queryClient = useQueryClient();

  const handleEditCustomCladColorPriceClick = () => {
    setEditCustomCladColorPriceClicked(true);
  };

  const handleConfirmCustomCladColorPriceClick = () => {
    if (!customCladColorPrice || customCladColorPrice === "2222.00") return;
    setIsUpdatingCustomCladColorPrice(true);
    setTimeout(async () => {
      try {
        await updateCustomCladColorPrice(
          quoteId,
          parseFloat(customCladColorPrice),
        );
        queryClient.invalidateQueries("QuoteCart");
        queryClient.invalidateQueries("Cart");
      } catch (e) {
        console.error(e);
      } finally {
        setEditCustomCladColorPriceClicked(false);
        setIsUpdatingCustomCladColorPrice(false);
      }
    }, 1200);
  };

  const handleCustomCladColorPriceChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { value } = event?.target;
    if (!/^\d*\.?\d{0,2}$/.test(value)) return;
    //drop the leading 0 once a digit follows it so the user doesn't have to
    //backspace it first ("05" -> "5", while "0.50" is left alone)
    setCustomCladColorPrice(value.replace(/^0+(?=\d)/, ""));
  };

  const handleCustomCladColorPriceBlur = () => {
    setCustomCladColorPrice((prev) => (prev ? Number(prev).toFixed(2) : prev));
  };

  const handleCustomCladColorPriceClickAway = () => {
    if (!editCustomCladColorPriceClicked || isUpdatingCustomCladColorPrice)
      return;
    setEditCustomCladColorPriceClicked(false);
    setCustomCladColorPrice(initialCustomCladColorPriceAsString);
  };

  return {
    customCladColorPrice,
    handleEditCustomCladColorPriceClick,
    editCustomCladColorPriceClicked,
    handleConfirmCustomCladColorPriceClick,
    isUpdatingCustomCladColorPrice,
    handleCustomCladColorPriceChange,
    handleCustomCladColorPriceBlur,
    handleCustomCladColorPriceClickAway,
  };
}

export default useCustomCladColorInput;
